import { createContext, useContext, useState, useEffect } from "react";
import { initializeB24Frame } from "@bitrix24/b24jssdk";
import { message } from "antd";
import certificateStore from "../store/CertificateStore";
import employeeStore from "../store/EmployeeStore";
import equipmentStore from "../store/EquipmentStore";
import objectStore from "../store/ObjectStore";
import PermissionStore from "../store/PermissionStore";

const BitrixContext = createContext(null);

export const useBitrix = () => useContext(BitrixContext);

export const BitrixProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [auth, setAuth] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let intervalId;

    const init = async () => {
      try {
        const b24 = await initializeB24Frame();

        if (!b24 || !b24.callMethod) {
          throw new Error("BX24 SDK не инициализирован");
        }

        // Получаем текущего пользователя
        const result = await b24.callMethod("user.current");
        const currentUser = result._data?.result;
        if (!currentUser) throw new Error("Не удалось получить пользователя");

        // Получаем токен
        const authData = b24.auth.getAuthData()?.access_token;
        if (!authData) throw new Error("Не удалось получить токен");

        setUser(currentUser);
        setAuth(authData);

        // Сохраняем в сторы
        const stores = [
          certificateStore,
          employeeStore,
          equipmentStore,
          objectStore,
          PermissionStore,
        ];

        stores.forEach(store => {
          store.setUser(currentUser.ID);
          store.setAuth(authData);
        });

        // Интервал для обновления токена каждые 4 минуты
        intervalId = setInterval(() => {
          const newToken = b24.auth.getAuthData()?.access_token;
          if (newToken && newToken !== auth) {
            setAuth(newToken);
            stores.forEach(store => store.setAuth(newToken));
          }
        }, 1000 * 60 * 4);

      } catch (err) {
        console.error("Ошибка инициализации Bitrix:", err);
        setError(err.message || "Неизвестная ошибка");
        message.error(err.message || "Ошибка Bitrix");
      } finally {
        setLoading(false);
      }
    };

    init();

    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, []);

  return (
    <BitrixContext.Provider value={{ user, auth, loading, error }}>
      {children}
    </BitrixContext.Provider>
  );
};
